import React from "react";
import SectionHead from "../components/SectionHead.jsx";
import CtaBand from "../components/CtaBand.jsx";
import Icon from "../components/icons/Icon.jsx";
import Check from "../components/icons/Check.jsx";
import VALUES from "../data/values.js";

const About = ({ go }) => (
  <div className="page">
    <section className="phero">
      <div className="wrap">
        <span className="eyebrow">About us</span>
        <h1 className="h-xl" style={{ maxWidth: "17ch" }}>A transport partner, not a subcontractor</h1>
        <p className="lead" style={{ marginTop: 24 }}>A4 Express is a UK transport and logistics operator moving
          courier consignments and heavy goods across the United Kingdom and Ireland — with our own fleet,
          our own drivers and one team accountable for the whole journey.</p>
      </div>
    </section>

    <section className="sec">
      <div className="wrap grid g2" style={{ gap: 60, alignItems: "start" }}>
        <div className="reveal">
          <span className="eyebrow">Our story</span>
          <h2 className="h-lg">Growth built on jobs done properly</h2>
          <p className="lead" style={{ marginTop: 22 }}>A4 Express started with a small fleet and a simple
            operating rule: quote honestly, arrive when we said we would, and answer the phone when something
            changes. That rule brought repeat work, and repeat work funded the fleet.</p>
          <p className="lead" style={{ marginTop: 18 }}>Today we run vehicles from 3.5 tonne electric vans to
            44 tonne articulated units, covering mainland UK, Northern Ireland and the Republic of Ireland. The
            operation is bigger, the rule has not changed.</p>
          <div style={{ display: "flex", gap: 12, marginTop: 30, flexWrap: "wrap" }}>
            <span className="pill"><Icon name="shield" s={16} /> Fully insured &amp; compliant</span>
            <span className="pill"><Icon name="clock" s={16} /> 24/7 operations</span>
            <span className="pill"><Icon name="leaf" s={16} /> Electric fleet in service</span>
          </div>
        </div>
        <div className="reveal" style={{ display: "grid", gap: 24 }}>
          <div className="card">
            <div className="ico"><Icon name="spark" /></div>
            <h3>Our mission</h3>
            <p>To move our customers' goods safely, on time and at a fair price — and to make transport the
              part of their operation they never have to worry about.</p>
          </div>
          <div className="card">
            <div className="ico"><Icon name="coverage" /></div>
            <h3>Our vision</h3>
            <p>To be the transport partner businesses across the UK and Ireland choose first: nationwide in
              reach, local in service, and among the cleanest fleets on the road.</p>
          </div>
        </div>
      </div>
    </section>

    <section className="sec mist">
      <div className="wrap">
        <SectionHead eyebrow="Core values" title="What every job is measured against" />
        <div className="grid g3">
          {VALUES.map((v, i) => (
            <article className="val reveal" key={v.t}>
              <div className="n">{String(i + 1).padStart(2, "0")}</div>
              <h3>{v.t}</h3><p>{v.d}</p>
            </article>
          ))}
        </div>
      </div>
    </section>

    <section className="sec">
      <div className="wrap grid g2" style={{ gap: 60, alignItems: "center" }}>
        <div className="reveal">
          <span className="eyebrow">Safety standards</span>
          <h2 className="h-lg">Compliance, checked daily</h2>
          <p className="lead" style={{ marginTop: 20 }}>Safety is managed as an operational routine, not an annual audit.</p>
          <div style={{ marginTop: 26 }}>
            {["Daily walk-around vehicle checks with defects reported and rectified before dispatch",
              "Scheduled maintenance and inspection intervals held ahead of statutory requirements",
              "Driver hours and tachograph data monitored continuously for compliance",
              "Loads secured to industry best practice, with weight and restraint checked at loading",
              "Fully licensed operator with goods-in-transit and public liability cover in place"].map((t) => (
              <div className="ck" key={t}><Check /><span>{t}</span></div>
            ))}
          </div>
        </div>
        <div className="reveal">
          <div className="card" style={{ padding: 40 }}>
            <span className="eyebrow">Customer commitment</span>
            <div className="quote">Every consignment gets a named contact, a realistic time and an honest
              answer if anything changes.</div>
            <div style={{ marginTop: 30, display: "grid", gap: 18 }}>
              {[["headset", "One point of contact", "A person who knows your account, not a ticket queue."],
                ["clock", "Proactive updates", "You hear about a delay from us, before you have to ask."],
                ["reliable", "Proof of delivery", "Signed, timed and available on request for every drop."]].map(([i, t, d]) => (
                <div className="info-row" key={t} style={{ padding: "14px 0" }}>
                  <span className="ic"><Icon name={i} s={20} /></span>
                  <div><div className="v">{t}</div><div className="muted" style={{ fontSize: ".9rem" }}>{d}</div></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>

    <CtaBand go={go} />
  </div>
);

export default About;
